import { Check, Eye } from "lucide-react";
import AdminListingActions from "../../components/admin/AdminListingActions";
import ListingImage from "../../components/ListingImage";
import AdminListToolbar from "../../components/admin/AdminListToolbar";
import AdminPagination from "../../components/admin/AdminPagination";
import { PARKING_FALLBACK } from "../../lib/parkingImages";
import { formatUsd } from "../../lib/currencyDisplay";

export default function AdminParkingTab({
  pendingParking,
  parkingSearchDraft,
  onParkingSearchDraftChange,
  onParkingSearch,
  parkingTotal,
  page,
  totalPages,
  onPageChange,
  onReview,
  onApprove,
  onDelete,
}) {
  return (
    <div className="zc-card overflow-hidden overflow-x-auto mt-4" data-testid="admin-pending-parking">
      <AdminListToolbar
        draft={parkingSearchDraft}
        onDraftChange={onParkingSearchDraftChange}
        onSearch={onParkingSearch}
        placeholder="Search parking by name, city, host…"
        testid="admin-parking-search"
        total={parkingTotal}
        shown={pendingParking.length}
      />
      {pendingParking.length === 0 && <div className="px-4 sm:px-6 py-10 text-center text-[var(--zc-text-3)] text-sm">No pending parking listings.</div>}
      {pendingParking.map(p => (
        <div key={p.spot_id} className="flex flex-col gap-3 sm:grid sm:grid-cols-[80px,1fr,auto] sm:items-center px-4 sm:px-6 py-4 border-b border-[var(--zc-border)] last:border-0">
          <ListingImage images={p.images} fallback={PARKING_FALLBACK} alt={p.name} className="w-20 h-14 object-cover rounded shrink-0" />
          <div className="min-w-0">
            <div className="zc-title text-lg">{p.name}</div>
            <div className="text-xs text-[var(--zc-text-3)]">{p.address}, {p.city} · ${formatUsd(p.price_per_hour)}/hr · by {p.host_name}</div>
          </div>
          <div className="flex flex-wrap gap-2 zc-stack-actions">
            <button onClick={() => onReview(p.spot_id)} className="px-3 h-9 zc-btn-ghost text-xs flex items-center gap-1" data-testid={`preview-${p.spot_id}`}>
              <Eye size={12} /> Review
            </button>
            <button onClick={() => onApprove(p.spot_id)} className="px-3 h-9 zc-btn-primary text-xs flex items-center gap-1" data-testid={`papprove-${p.spot_id}`}>
              <Check size={12} /> Approve
            </button>
            <AdminListingActions
              item={{ ...p, type: "parking", listing_id: p.spot_id }}
              onDelete={onDelete}
              size="md"
            />
          </div>
        </div>
      ))}
      <AdminPagination page={page} totalPages={totalPages} onPageChange={onPageChange} testid="admin-parking-pagination" />
    </div>
  );
}
